import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./IndustriesWeSupport.css";
import Layout from "../PageLayout/Layout";

const INSURANCE_CONTENT = {
  title:
    "Underwriting and claims intelligence for regulated insurers — from submission to decision, fully explainable.",
  points: [
    "Real-time fraud & risk scoring",
    "Every decision, evidence-backed",
    "Full audit trail on every override",
  ],
};

const PRODUCTS = [
  {
    id: "insurance",
    label: "Insurance",
    status: "LIVE",
    ...INSURANCE_CONTENT,
    cta: { to: "/ProductInsurance", text: "Learn More" },
  },
  {
    id: "intelligence",
    label: "Intelligence",
    status: "LIVE",
    ...INSURANCE_CONTENT,
    cta: { to: "/ProductIntelligence", text: "Learn More" },
  },
  {
    id: "finance",
    label: "Finance",
    status: "SOON",
    ...INSURANCE_CONTENT,
    cta: null,
  },
  {
    id: "healthcare",
    label: "Healthcare",
    status: "SOON",
    ...INSURANCE_CONTENT,
    cta: null,
  },
];

function ProductDashboardMock() {
  return (
    <div className="hw-products-frame">
      <div className="hw-products-frame__chrome" aria-hidden="true">
        <span className="hw-products-frame__dot" />
        <span className="hw-products-frame__dot" />
        <span className="hw-products-frame__dot" />
      </div>
      <img
        className="hw-products-frame__image"
        src="/images/Admin 1.svg"
        alt="Highwatch product overview dashboard"
      />
    </div>
  );
}

export default function IndustriesWeSupport() {
  const [active, setActive] = useState("insurance");
  const [slideKey, setSlideKey] = useState(0);
  const product = PRODUCTS.find((p) => p.id === active) || PRODUCTS[0];

  useEffect(() => {
    setSlideKey((k) => k + 1);
  }, [active]);

  return (
    <>
      {/* Legacy mobile industries block — unused on home today; kept for reuse */}
      <section className="industries-mobile">
        <Layout>
          <div className="container">
            <section className="hero">
              <div className="internal-hero-badge">
                <img src="/icons/sitemap.svg" alt="sitemap Icon" />
                <span>Industries We Support</span>
              </div>
              <h1>
                Built for how your team <br /> <span>actually works.</span>
              </h1>
              <p>
                Whether you’re running a clinic, managing freight, or building the next
                big thing — Highwatch AI connects your tools and finds your answers.
              </p>
            </section>
          </div>
        </Layout>
      </section>

      {/* Desktop Products + Enterprise CTA */}
      <section className="hw-products">
        <div className="hw-products__intro">
          <p className="hw-products__eyebrow">PRODUCTS</p>
          <h2>One layer. Every regulated vertical.</h2>
          <p className="hw-products__sub">
            Explore how Highwatch operates across industries — each vertical built on the
            same explainable core.
          </p>
        </div>

        <div className="hw-products__panel">
          <div className="hw-products__tabs" role="tablist">
            {PRODUCTS.map((item) => {
              const isSoon = item.status === "SOON";
              return (
                <button
                  key={item.id}
                  type="button"
                  role="tab"
                  aria-selected={active === item.id}
                  aria-disabled={isSoon}
                  disabled={isSoon}
                  className={`hw-products__tab ${active === item.id ? "is-active" : ""} ${
                    isSoon ? "is-soon" : ""
                  }`}
                  onClick={() => {
                    if (!isSoon) setActive(item.id);
                  }}
                >
                  {item.label}
                  <em className={item.status === "LIVE" ? "is-live" : "is-soon"}>
                    {item.status}
                  </em>
                </button>
              );
            })}
          </div>

          <div className="hw-products__body">
            <div className="hw-products__copy">
              <h3>{product.title}</h3>
              <ul>
                {product.points.map((point) => (
                  <li key={point}>
                    <span aria-hidden="true">✓</span>
                    {point}
                  </li>
                ))}
              </ul>
              {product.cta ? (
                <Link className="hw-products__cta" to={product.cta.to}>
                  {product.cta.text} →
                </Link>
              ) : null}
            </div>
            <div className="hw-products__visual" key={slideKey}>
              <ProductDashboardMock />
            </div>
          </div>
        </div>

        <div className="hw-enterprise">
          <div>
            <p className="hw-enterprise__eyebrow">HIGHWATCH ENTERPRISE</p>
            <h3>Need it all, unified?</h3>
            <p>
              Custom enterprise AI platform for complex operations — every vertical,
              unlimited scale, private deployment.
            </p>
          </div>
          <Link to="/Contact" className="hw-enterprise__btn">
            Talk to sales →
          </Link>
        </div>
      </section>
    </>
  );
}
